import type { BookingDetails } from 'routes/tourOperator/bookings/types/bookingDetails/bookingDetailsTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type BookingTravellersState = {
  value: BookingDetails['travellers'] | null;
};

const initialState: BookingTravellersState = {
  value: null,
};

function setBookingTravellersFunction(
  state: BookingTravellersState,
  action: PayloadAction<BookingTravellersState['value']>
) {
  return {
    ...state,
    value: action.payload,
  };
}

function resetStateFunction() {
  return initialState;
}

const slice = createSlice({
  name: 'bookingDetails.bookingTravellers',
  initialState,
  reducers: {
    setBookingTravellers: setBookingTravellersFunction,
    resetState: resetStateFunction,
  },
});

export const { setBookingTravellers, resetState } = slice.actions;
export default slice.reducer;
